<template>
  <div class="bg-white rounded-[32px] border border-slate-200 flex flex-col h-full overflow-hidden group hover:border-[#F2C94C]/40 hover:shadow-lg transition-all duration-300">
    <div class="p-6 border-b border-slate-100 flex items-center justify-between">
      <h3 class="text-sm font-black text-slate-900 uppercase tracking-[0.2em] flex items-center gap-2">
        <IconAward class="w-4 h-4 text-[#F2C94C]" /> 专家贡献排行榜
      </h3>
    </div>
    <div class="flex-1 overflow-y-auto p-4 space-y-3">
      <div
        v-for="(expert, idx) in experts"
        :key="expert.id"
        @click="handleExpertClick(expert)"
        class="group flex items-center gap-4 p-3 rounded-2xl hover:bg-slate-50 cursor-pointer transition-all duration-300"
      >
        <div class="relative">
          <img :src="expert.avatar" class="w-12 h-12 rounded-full border-2 border-slate-100 group-hover:border-[#F2C94C] transition-all duration-300" referrerPolicy="no-referrer" />
          <div class="absolute -bottom-1 -right-1 w-5 h-5 bg-[#F2C94C] text-white text-[10px] font-black rounded-full flex items-center justify-center border-2 border-white">
            {{ idx + 1 }}
          </div>
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-sm font-bold text-slate-900 truncate group-hover:text-[#F2C94C] transition-colors duration-300">{{ expert.name }}</div>
          <div class="text-[10px] text-slate-500 truncate">
            {{ expert.department ? `${expert.department} · ${expert.position || expert.title}` : expert.title }}
          </div>
          <div class="flex items-center gap-3 mt-1">
            <span class="text-[10px] text-[#F2C94C] font-bold">{{ expert.points.toLocaleString() }}积分</span>
            <span class="text-[10px] text-slate-400">{{ expert.stats.prescriptions }}次贡献</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IconAward } from '../icons'

export default {
  name: 'ExpertLeaderboard',
  components: {
    IconAward
  },
  props: {
    experts: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleExpertClick(expert) {
      this.$router.push(`/expert/${expert.id}`)
      this.$emit('expert-click', expert)
    }
  }
}
</script>
